// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__3-1UZ","paymentInfo":"style_paymentInfo__ZXUm0","loadingContainer":"style_loadingContainer__2QzJa","spinning":"style_spinning__3Zfll"};